import { render, staticRenderFns } from "./spermsMorphologyOfTraningBulls.vue?vue&type=template&id=55998e94&scoped=true&"
import script from "./spermsMorphologyOfTraningBulls.vue?vue&type=script&lang=js&"
export * from "./spermsMorphologyOfTraningBulls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55998e94",
  null
  
)

export default component.exports